import circleCheck2 from "@/assets/icons/circle-check-2.svg";
import { Card, CardContent } from "@/components/ui/card";
import { useApplicationByEdition } from "@/hooks/application-by-edition.hook";
import { useCurrentUserProfile } from "@/hooks/current-user-profile.hook";
import { useQuizById } from "@/hooks/quiz-by-id.hook";
import { cn } from "@/lib/utils";
import { currentEditionIdAtom } from "@/store/edition-id.store";
import { useAtomValue } from "jotai";
import { FC, HTMLAttributes } from "react";

type QuizIncompleteBannerProps = HTMLAttributes<HTMLDivElement>;

const QuizIncompleteBanner: FC<QuizIncompleteBannerProps> = (props) => {
  const editionId = useAtomValue(currentEditionIdAtom);

  const { data: userProfile } = useCurrentUserProfile();

  const { data: application } = useApplicationByEdition({
    companyId: userProfile?.companyId || "",
    editionId,
  });

  const { data: quiz } = useQuizById({
    companyId: userProfile?.companyId || "",
    applicationQuizId: application?.quizId || "",
  });

  if (quiz?.status === "INCOMPLETE") {
    return (
      <Card className={cn(props.className)}>
        <CardContent className="pt-4">
          <div className="flex items-start gap-4">
            <div className="shrink-0">
              <img
                src={circleCheck2}
                width={20}
                height={20}
                className="inline-block"
              />
            </div>

            <div className="flex grow flex-col gap-2 text-[#293038]">
              <h3 className="grow text-lg">El cuestionario ha sido cerrado</h3>

              <p className="text-sm leading-relaxed">
                La etapa de envío de postulaciones ha finalizado. Este
                cuestionario ya no puede ser editado.
              </p>
            </div>
          </div>
        </CardContent>
      </Card>
    );
  }
};

export default QuizIncompleteBanner;
